import React from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import { CreatorScreen as BaseCreatorScreen } from '@configuratorware/configurator-frontendgui/App/Modules/Creator/CreatorScreen';
import BaseOption from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Components/Option';
import CustomAmountPriceContainer from '../Containers/AmountPrice/AmountPrice';
import CustomProductPartsListContainer from '../Containers/ProductsPartList/ProductsPartList';
import CustomOptionsListContainer from '../Containers/OptionsList/OptionsList';
import Header from '@configuratorware/configurator-frontendgui/App/Shared/Containers/Header';
import HeaderLogo from '../Components/HeaderLogo/HeaderLogo';
import ThemeProvider from '../Custom/ThemeProvider';

const AmountPriceContainer = (props) => <CustomAmountPriceContainer {...props} />;

const ProductsPartContainer = (dispatchAction, onOptionClassificationSelect, selectOptionClassification) => (
  <CustomProductPartsListContainer
    onSelect={(optionClassification) => {
      onOptionClassificationSelect(dispatchAction, optionClassification, selectOptionClassification);
    }}
  />
);

const OptionsListContainer = (props) => (
  <CustomOptionsListContainer {...props} OptionComponent={BaseOption} />
);

const CreatorScreen = (props) => (
  <BaseCreatorScreen
    {...props}
    renderAmountPrice={AmountPriceContainer}
    renderProductParts={ProductsPartContainer}
    OptionsListContainer={OptionsListContainer}
    renderHeader={() => (
      <>
        <Header />
        <HeaderLogo />
      </>
    )}
  />
);

const ConfiguratorScreen = (props) => (
  <ConnectedConfiguratorScreen
    {...props}
    CreatorScreen={CreatorScreen}
    ThemeProvider={ThemeProvider}
  />
);

export default ConfiguratorScreen;
